import { useEffect } from 'react'
import { useGetQuestionsQuery, useGetSurveyAnswersQuery, useGetSurveyStatsQuery } from 'src/redux/Api/surveysApi'
import style from '../../surveys.module.scss'

interface Props {
  id: string
}

const SurveyAnalytics = ({ id }: Props) => {
  const { data: answers, isFetching, isError } = useGetSurveyAnswersQuery(+id)
  const { data: questions } = useGetQuestionsQuery(+id)
  const { data: stats } = useGetSurveyStatsQuery(+id, { refetchOnMountOrArgChange: true })

  const percentOfViews = (value: number) =>
    stats && stats.views ? ` (${((value / stats.views) * 100).toFixed(1)}%)` : ''

  useEffect(() => {
    console.log(answers)
  }, [answers])

  const exportDataCsv = () => {
    if (!answers || !questions) return
    const csvObj = answers.map((a) => {
      let answersList: object = {}
      questions.forEach((q) => {
        const answer = a.answers.find((ans) => ans.questionId === q.id)
        return (answersList = { ...answersList, [q.questionText]: answer?.answer || '' })
      })
      return {
        data: new Date(a.createdAt).toLocaleDateString('en-UA', { day: '2-digit', month: '2-digit', year: 'numeric' }),
        user: a.webUser,
        device: a.device,
        page: a.page,
        ...answersList
      }
    })
    const csv = [Object.keys(csvObj[0]).join(';'), ...csvObj.map((obj) => Object.values(obj).join(';'))].join('\n')
    const blob = new Blob([csv], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'answers.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div className={style.syrvey_analytics}>
      {isFetching && <p>Loading...</p>}
      {isError && <p>Error</p>}
      {stats && (
        <div className={style.stats}>
          <div className={style.stats_item}>
            <span>Views</span>
            <b>{stats.views}</b>
          </div>
          <div className={style.stats_item}>
            <span>Interactions</span>
            <b>
              {stats.interactions}
              <small>{percentOfViews(stats.interactions)}</small>
            </b>
          </div>
          <div className={style.stats_item}>
            <span>Closed</span>
            <b>
              {stats.closes}
              <small>{percentOfViews(stats.closes)}</small>
            </b>
          </div>
          <div className={style.stats_item}>
            <span>Answers</span>
            <b>
              {stats.answers}
              <small>{percentOfViews(stats.answers)}</small>
            </b>
          </div>
        </div>
      )}
      {answers && questions && (
        <>
          <p>Answers: {answers.length}</p>
          <button className="btn" onClick={exportDataCsv}>
            Export to CSV
          </button>
          <div className={style.table_wrapper}>
            <table>
              <thead>
                <tr>
                  <th>Data</th>
                  <th>User</th>
                  <th>Device</th>
                  <th>Page</th>
                  {questions.map((q) => {
                    return (
                      <th data-id={q.id} key={q.id}>
                        {q.questionText}
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {answers.map((a) => {
                  return (
                    <tr key={a.id}>
                      <td>
                        {new Date(a.createdAt).toLocaleDateString('en-UA', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric'
                        })}
                      </td>
                      <td>{a.webUser}</td>
                      <td>{a.device}</td>
                      <td>{a.page}</td>
                      {questions.map((q) => {
                        const answer = a.answers.find((ans) => ans.questionId === q.id)
                        return (
                          <td data-id={q.id} key={q.id}>
                            {answer?.answer}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}

export default SurveyAnalytics
